import { YouTube } from 'components/blog-posts/youtube';
import css from './custom-html.module.css';
export function CustomHtml({
  html
}: {
  html: string;
}) {
  if (html.includes('<iframe')) {
    const matches = html.match(/<iframe [^>]*src="[^"]*"[^>]*>/gm);
    if (matches) {
      const [source] = matches.map(x => x.replace(/.*src="([^"]*)".*/, '$1'));
      return <YouTube url={source} />;
    }
  }
  return <div className={css.customHtml} dangerouslySetInnerHTML={{
    __html: html
  }} data-sentry-component="CustomHtml" data-sentry-source-file="custom-html.tsx" />;
}